/* Lot 1 : compte à rebours des offres, filtres et « Voir plus » en AJAX (API de rendu de section), plan des collections,
   onglet Collections de la recherche. S'appuie sur window.RV (rv-core.js). */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  var plural = function (n, w) { return (window.RV && RV.plural) ? RV.plural(n, w) : n + " " + w + (n > 1 ? "s" : ""); };
  var T = function (k, v) { return window.RV && RV.t ? RV.t(k, v) : k; };
  var many = function (n) { return window.RV && RV.lang && RV.lang !== "fr" ? n !== 1 : n > 1; };

  /* ---------- Compte à rebours : prochain lundi 5 h, heure de Paris ---------- */
  function parisParts(d) {
    var f = new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/Paris", weekday: "short", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false });
    var o = {}; f.formatToParts(d).forEach(function (p) { o[p.type] = p.value; }); return o;
  }
  function nextMonday5() {
    var now = new Date(), p = parisParts(now);
    var days = { Mon: 0, Tue: 1, Wed: 2, Thu: 3, Fri: 4, Sat: 5, Sun: 6 }[p.weekday];
    var secToday = (+p.hour % 24) * 3600 + (+p.minute) * 60 + (+p.second);
    var until = (7 - days) % 7 * 86400 + 5 * 3600 - secToday;
    if (until <= 0) until += 7 * 86400;
    return until;
  }
  function tick() {
    var left = nextMonday5();
    var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
    $$("[data-rv-countdown]").forEach(function (el) {
      el.innerHTML = "<div><b>" + d + "</b><small>" + T(many(d) ? "lot1_js.days" : "lot1_js.day") + "</small></div><div><b>" + ("0" + h).slice(-2) + "</b><small>" + T("lot1_js.hours") + "</small></div><div><b>" + ("0" + m).slice(-2) + "</b><small>" + T("lot1_js.min") + "</small></div>" + (reduce ? "" : "<div><b>" + ("0" + s).slice(-2) + "</b><small>" + T("lot1_js.sec") + "</small></div>");
    });
  }
  if ($("[data-rv-countdown]")) { tick(); setInterval(tick, reduce ? 60000 : 1000); }

  /* ---------- Offres : filtre par remise (affiches de la page) ---------- */
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-rv-tier]"); if (!b) return;
    var v = b.getAttribute("data-rv-tier");
    $$("[data-rv-tier]").forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); });
    var n = 0;
    $$(".rv-cell").forEach(function (c) { var ok = !v || c.getAttribute("data-tier") === v; c.hidden = !ok; if (ok) n++; });
    var cnt = $("[data-rv-count]"); if (cnt) cnt.textContent = v ? plural(n, "affiche") + " " + T("lot1_js.at_discount", { pct: v }) : "";
  });

  /* ---------- Collections : filtres, tri et « Voir plus » sans recharger ---------- */
  var coll = $("[data-rv-coll]");
  if (coll && window.fetch && window.DOMParser) {
    var sid = coll.getAttribute("data-section");
    var hdrOffset = function () { var h = $(".rv-hdr-section") || $("header"); return (h ? h.getBoundingClientRect().height : 90) + 12; };
    var fetchSection = function (url) {
      var u = new URL(url, location.href); u.searchParams.set("section_id", sid);
      return fetch(u.toString(), { credentials: "same-origin" }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (t) { return new DOMParser().parseFromString(t, "text/html"); });
    };
    var keepOnResults = function () {
      var res = $(".rv-results", coll), f = $("[data-rv-filters]", coll) || res; if (!res) return;
      var top = f.getBoundingClientRect().top;
      if (top < 0 || top > window.innerHeight * 0.6) {
        window.scrollTo({ top: window.scrollY + top - hdrOffset(), behavior: reduce ? "auto" : "smooth" });
      }
    };
    var swap = function (doc) {
      ["[data-rv-filters]", ".activebar", "[data-rv-count]", ".rv-results"].forEach(function (sel) {
        var a = $(sel, coll), b = $(sel, doc); if (a && b) a.replaceWith(b);
      });
    };
    var go = function (url) {
      var res = $(".rv-results", coll); if (res) res.classList.add("is-loading");
      fetchSection(url).then(function (doc) {
        swap(doc);
        var u = new URL(url, location.href); u.searchParams.delete("section_id");
        history.replaceState(null, "", u.pathname + u.search);
        keepOnResults();
      }).catch(function () { location.href = url; });
    };
    coll.addEventListener("click", function (e) {
      var a = e.target.closest("a[data-rv-f]"); if (a && coll.contains(a)) { e.preventDefault(); var d = a.closest("details"); if (d) d.open = false; go(a.href); return; }
      var m = e.target.closest("a[data-rv-next]"); if (m) {
        e.preventDefault(); m.setAttribute("aria-busy", "true"); m.textContent = T("lot1_js.loading");
        fetchSection(m.href).then(function (doc) {
          var grid = $("[data-rv-grid]", coll), ng = $("[data-rv-grid]", doc);
          if (grid && ng) { var first = ng.firstElementChild; while (ng.firstElementChild) grid.appendChild(ng.firstElementChild); if (first) { var l = first.querySelector("a"); if (l) l.focus({ preventScroll: true }); } }
          var mb = $("[data-rv-more]", coll), nmb = $("[data-rv-more]", doc);
          if (mb) { if (nmb) mb.replaceWith(nmb); else mb.remove(); }
          var pg = $(".rv-pages", coll), npg = $(".rv-pages", doc); if (pg && npg) pg.replaceWith(npg);
          document.dispatchEvent(new CustomEvent("rv:grid-append"));
        }).catch(function () { location.href = m.href; });
      }
    });
    coll.addEventListener("change", function (e) {
      var s = e.target.closest("[data-rv-sort] select"); if (!s) return;
      var f = s.form, u = new URL(f.action, location.href);
      new FormData(f).forEach(function (v, k) { u.searchParams.append(k, v); });
      go(u.toString());
    });
    document.addEventListener("click", function (e) {
      $$("[data-rv-filters] details[open]", coll).forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
    });

    /* Tri : menu déroulant maison (le select natif reste pour le sans-script et sert de source) */
    var ddClose = function (dd, focusBtn) {
      if (!dd) return; var b = $(".rv-dd-btn", dd), l = $(".rv-dd-list", dd);
      b.setAttribute("aria-expanded", "false"); l.hidden = true; if (focusBtn) b.focus();
    };
    var ddOpen = function (dd) {
      var b = $(".rv-dd-btn", dd), l = $(".rv-dd-list", dd);
      b.setAttribute("aria-expanded", "true"); l.hidden = false;
      var sel = $('[aria-selected="true"]', l) || $("li", l);
      $$("li", l).forEach(function (li) { li.classList.toggle("is-act", li === sel); });
      l.setAttribute("aria-activedescendant", sel.id); l.focus();
    };
    var ddPick = function (dd, li) {
      var sel = $("select", dd); sel.value = li.getAttribute("data-value");
      ddClose(dd, true); sel.dispatchEvent(new Event("change", { bubbles: true }));
    };
    coll.addEventListener("click", function (e) {
      var b = e.target.closest(".rv-dd-btn");
      if (b) { var dd = b.closest("[data-rv-dd]"); if (b.getAttribute("aria-expanded") === "true") ddClose(dd); else ddOpen(dd); return; }
      var li = e.target.closest(".rv-dd-list li"); if (li) { ddPick(li.closest("[data-rv-dd]"), li); return; }
    });
    document.addEventListener("click", function (e) {
      $$("[data-rv-dd]", coll).forEach(function (dd) { if (!dd.contains(e.target)) ddClose(dd); });
    });
    coll.addEventListener("keydown", function (e) {
      var l = e.target.closest(".rv-dd-list"); if (!l) return;
      var dd = l.closest("[data-rv-dd]"), items = $$("li", l), i = items.findIndex(function (x) { return x.classList.contains("is-act"); });
      if (e.key === "Escape" || e.key === "Tab") { if (e.key === "Escape") e.preventDefault(); ddClose(dd, e.key === "Escape"); return; }
      if (e.key === "ArrowDown" || e.key === "ArrowUp" || e.key === "Home" || e.key === "End") {
        e.preventDefault();
        i = e.key === "Home" ? 0 : e.key === "End" ? items.length - 1 : Math.max(0, Math.min(items.length - 1, i + (e.key === "ArrowDown" ? 1 : -1)));
        items.forEach(function (x, k) { x.classList.toggle("is-act", k === i); }); l.setAttribute("aria-activedescendant", items[i].id); return;
      }
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); if (items[i]) ddPick(dd, items[i]); }
    });
  }

  /* ---------- Toutes nos affiches : filtre instantané ---------- */
  var norm = function (s) { return (s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^a-z0-9 ]/g, " ").trim(); };
  var plan = $("[data-rv-plan]");
  if (plan) {
    var inp = $("[data-rv-plan-in]", plan), out = $("[data-rv-plan-n]", plan);
    inp.addEventListener("input", function () {
      var q = norm(inp.value), n = 0;
      $$(".rv-az-list [data-rv-plan-item]", plan).forEach(function (li) { var ok = !q || norm(li.getAttribute("data-t")).indexOf(q) > -1; li.hidden = !ok; if (ok) n++; });
      $$(".plan [data-rv-plan-item]", plan).forEach(function (li) { var ok = !q || norm(li.textContent).indexOf(q) > -1; li.hidden = !ok; });
      $$("[data-rv-az]", plan).forEach(function (s) { s.hidden = !$$("[data-rv-plan-item]:not([hidden])", s).length; });
      out.textContent = q ? (n ? T("lot1_js.plan_found", { n: plural(n, "collection"), q: inp.value.trim() }) : T("lot1_js.plan_none", { q: inp.value.trim() })) : "";
    });
  }
  /* search page (collections tab, did-you-mean): moved to assets/rv-search.js (20/10/2026) */
})();

/* ---------- Collections, mobile : fenêtre « Filtrer » et feuille « Trier » (retours de Romain du 07/10) ---------- */
(function () {
  var coll = document.querySelector("[data-rv-coll]"); if (!coll) return;
  var fm = coll.querySelector("[data-rv-fm]"), sheet = coll.querySelector("[data-rv-sheet]"); if (!fm) return;
  var body = fm.querySelector("[data-rv-fm-body]"), opener = null, marks = [];
  var mobile = function () { return window.matchMedia("(max-width: 899px)").matches; };
  var setH = function () { var h = document.querySelector(".rv-hdr-section") || document.querySelector("header"); var st = h ? getComputedStyle(h).position : ""; document.documentElement.style.setProperty("--hdr-h", (h && (st === "sticky" || st === "fixed") ? Math.round(h.getBoundingClientRect().height) : 0) + "px"); };
  setH(); window.addEventListener("resize", setH);
  var nodes = function () { return [coll.querySelector("[data-rv-filters]"), coll.querySelector(".rv-aside")].filter(Boolean); };
  var count = function () {
    var c = coll.querySelector("[data-rv-count]"), b = fm.querySelector("[data-rv-fm-see]"); if (!c || !b) return;
    var m = (c.textContent || "").match(/\d[\d\s]*/), t = m ? (window.RV && RV.t ? RV.t("lot1_js.see_n", { n: m[0].trim() }) : "Voir les " + m[0].trim() + " affiches") : ""; if (t && b.textContent !== t) b.textContent = t;
  };
  var open = function (dlg, btn) {
    opener = btn;
    if (dlg === fm) {
      marks = nodes().map(function (n) { var mk = document.createComment("rv-fm"); n.parentNode.insertBefore(mk, n); body.appendChild(n); return mk; });
      var d = body.querySelector("[data-rv-aside]"); if (d) d.open = true;
      count();
    }
    dlg.hidden = false; document.documentElement.style.overflow = "hidden";
    var x = dlg.querySelector("[data-rv-fm-close]"); if (x) x.focus();
  };
  var close = function () {
    [fm, sheet].forEach(function (dlg) { if (dlg) dlg.hidden = true; });
    if (marks.length) {
      var cur = [body.querySelector("[data-rv-filters]"), body.querySelector(".rv-aside")].filter(Boolean);
      marks.forEach(function (mk, i) { var n = cur[i] || body.children[0]; if (n && mk.parentNode) mk.parentNode.insertBefore(n, mk); if (mk.parentNode) mk.parentNode.removeChild(mk); });
      marks = [];
    }
    document.documentElement.style.overflow = "";
    if (opener) opener.focus();
  };
  coll.addEventListener("click", function (e) {
    var t = e.target;
    if (t.closest("[data-rv-fm-open]")) { e.preventDefault(); open(fm, t.closest("button")); return; }
    if (t.closest("[data-rv-sort-open]") && sheet) { e.preventDefault(); open(sheet, t.closest("button")); return; }
    if (t.closest("[data-rv-fm-close]")) { e.preventDefault(); close(); return; }
    var sv = t.closest("[data-rv-sortv]");
    if (sv) { var u = new URL(location.href); u.searchParams.set("sort_by", sv.getAttribute("data-rv-sortv")); u.searchParams.delete("page"); location.href = u.toString(); }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && ((fm && !fm.hidden) || (sheet && !sheet.hidden))) close(); });
  /* le compteur est remplacé à chaque filtrage (rv-lot1 swap) : on ne recompte que si le fenêtre est ouverte */
  new MutationObserver(function () { if (!fm.hidden) count(); }).observe(coll, { childList: true, subtree: true });
  window.addEventListener("resize", function () { if (!mobile() && !fm.hidden) close(); });
})();
